var exports = {
  "Qs": "ChannelCreateModal.module__content___NF9wOH",
  "HW": "ChannelCreateModal.module__channelTypeSection___NF9wOH",
  "ir": "ChannelCreateModal.module__channelTypeLabel___NF9wOH",
  "S7": "ChannelCreateModal.module__nameRow___NF9wOH",
  "K3": "ChannelCreateModal.module__nameInput___NF9wOH",
};

module.exports = exports;
